import { render } from "./QRCode.vue?vue&type=template&id=68e0d2b1&scoped=true"
import script from "./QRCode.vue?vue&type=script&lang=js"
export * from "./QRCode.vue?vue&type=script&lang=js"

import "./QRCode.vue?vue&type=style&index=0&id=68e0d2b1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68e0d2b1"]])

export default __exports__